import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PaymentInfoAdyen} from '@core/models';
import {PaymentService} from '@core/services/payment.service';
import {WalletService} from '@core/services/wallet.service';

@Component({
  selector: 'app-payment-adyen-confirmed',
  templateUrl: './payment-adyen-confirmed.component.html',
  styleUrl: './payment-adyen-confirmed.component.scss'
})
export class PaymentAdyenConfirmedComponent implements OnInit {

  paymentInfo?: PaymentInfoAdyen

  constructor(private route: ActivatedRoute, private router: Router, private paymentService: PaymentService) {}

  ngOnInit() {
    this.route.data.subscribe((data: any) => {
      this.paymentInfo = data.data.data
      if (this.paymentInfo?.status == 'completed') {
        const transactionInfo = JSON.parse(sessionStorage.getItem('adyensessionInfo') ?? '{}')
        sessionStorage.removeItem('adyensessionInfo')
        sessionStorage.removeItem('location_code')
        this.paymentService.transactionInfo.set({
          number: transactionInfo.reference ?? "",
          amount: transactionInfo.amount.value ?? 0
        })
        setTimeout(() => {
          this.router.navigate(['./success'], { relativeTo: this.route.parent })
        }, 500)

      } else {
        setTimeout(() => {
          this.router.navigate(['./failed'], { relativeTo: this.route.parent })
        }, 500)

      }
    })
  }

}
